import * as React from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'
import { PerformanceReviewsTemplatestListPageDocument } from 'generated/resources/graphql'
import { PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum as TemplateType } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CustomTemplatesDataTable } from 'modules/performance_process/components/templates/CustomTemplatesDataTable'
import { PredefinedTemplatesDataTable } from 'modules/performance_process/components/templates/PredefinedTemplatesDataTable'
import { isValidTemplateType } from 'modules/performance_process/lib/templateType'

const TemplatesListPage = () => {
  const [currentTab, setCurrentTab] = React.useState<TemplateType>('predefined')
  const { data, loading, error } = useQuery(PerformanceReviewsTemplatestListPageDocument)
  const canSeeTemplates = data?.performance?._policies?.seeProcessTemplates?.can
  const canCreateTemplates = data?.performance?._policies?.createCustomTemplate?.can

  return (
    <ResponsivePage.Body loading={loading} authorized={canSeeTemplates} error={error}>
      <Tabs
        currentId={currentTab}
        onTabClicked={(tab) => isValidTemplateType(tab) && setCurrentTab(tab)}
      >
        <Tabs.Tab
          key={'predefined'}
          id={'predefined'}
          label={i18n.t('performance_process.reviews.templates.predefined')}
        >
          <Box paddingTop="s32">
            <PredefinedTemplatesDataTable canCreateTemplates={canCreateTemplates} />
          </Box>
        </Tabs.Tab>
        <Tabs.Tab
          key={'custom'}
          id={'custom'}
          label={i18n.t('performance_process.reviews.templates.custom')}
        >
          <Box paddingTop="s32">
            <CustomTemplatesDataTable canCreateTemplates={canCreateTemplates} />
          </Box>
        </Tabs.Tab>
      </Tabs>
    </ResponsivePage.Body>
  )
}
export default TemplatesListPage
